import { lazy, type FC } from 'react';
import { useSecondaryMarketService } from 'src/apis/secondary-market-service/use-secondary-market-service';
import { PageSpinner } from 'src/components/spinner-container';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

const Page = lazy(() => import('./page'));

export const NotificationSettings: FC = () => {
  const secondaryMarketService = useSecondaryMarketService();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  if (secondaryMarketService.response === null) return <PageSpinner />;

  return (
    <Page
      monolithUser={monolithUser}
      secondaryMarketService={secondaryMarketService}
    />
  );
};
